(function () {
  if (window.FenderDrop) return;
  var FD = (window.FenderDrop = { timer: null, poll: null });

  function roots() {
    return document.querySelectorAll('[data-fd-root]');
  }
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }
  function setText(sel, v) {
    document.querySelectorAll(sel).forEach(function (e) {
      if (e.textContent !== v) e.textContent = v;
    });
  }
  function previewState() {
    /* Only honoured on non-published themes (preview / editor), never on the live theme. */
    try {
      var t = window.Shopify && window.Shopify.theme;
      if (t && t.role && t.role !== 'main') {
        var m = /[?&]fd_state=(pre|pending|live)\b/.exec(window.location.search);
        if (m) return m[1];
      }
    } catch (e) {}
    return null;
  }
  function cachedLive(handle) {
    try {
      return window.sessionStorage.getItem('fd_live_' + handle) === '1';
    } catch (e) {
      return false;
    }
  }
  function cacheLive(handle) {
    try {
      window.sessionStorage.setItem('fd_live_' + handle, '1');
    } catch (e) {}
  }
  function setState(s) {
    roots().forEach(function (r) {
      if (r.getAttribute('data-state') !== s) r.setAttribute('data-state', s);
    });
    document.documentElement.setAttribute('data-fd-state', s);
    if (s === 'live') {
      document.querySelectorAll('[data-fd-href]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('data-fd-href'));
      });
    }
  }
  function render(diff) {
    var s = Math.max(0, Math.floor(diff / 1000));
    setText('[data-fd-d]', pad(Math.floor(s / 86400)));
    setText('[data-fd-h]', pad(Math.floor((s % 86400) / 3600)));
    setText('[data-fd-m]', pad(Math.floor((s % 3600) / 60)));
    setText('[data-fd-s]', pad(s % 60));
  }
  function startCountdown(launch) {
    if (FD.timer) clearInterval(FD.timer);
    render(launch - Date.now());
    FD.timer = setInterval(function () {
      var diff = launch - Date.now();
      if (diff <= 0) {
        clearInterval(FD.timer);
        FD.timer = null;
        FD.apply();
      } else {
        render(diff);
      }
    }, 1000);
  }
  function startPolling(handle) {
    if (FD.poll) return;
    function check() {
      fetch('/products/' + handle + '.js', {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (r.ok) {
            clearInterval(FD.poll);
            FD.poll = null;
            cacheLive(handle);
            setState('live');
          }
        })
        .catch(function () {});
    }
    check();
    FD.poll = setInterval(check, 15000);
  }

  FD.apply = function () {
    var first = roots()[0];
    if (!first) return;
    var launch = Date.parse(first.getAttribute('data-launch'));
    var handle = first.getAttribute('data-handle');

    var forced = previewState();
    if (forced) {
      setState(forced);
      if (forced === 'pre' && !isNaN(launch)) startCountdown(launch);
      return;
    }
    if (isNaN(launch)) return;

    if (Date.now() < launch) {
      setState('pre');
      startCountdown(launch);
      return;
    }
    if (FD.timer) {
      clearInterval(FD.timer);
      FD.timer = null;
    }
    if (first.getAttribute('data-state') === 'live' || cachedLive(handle)) {
      setState('live');
      return;
    }
    setState('pending');
    startPolling(handle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', FD.apply);
  } else {
    FD.apply();
  }
  document.addEventListener('shopify:section:load', FD.apply);
})();